import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import toaster from 'react-hot-toast';
import { CentsAssistInfo } from '~api/assist/getCentsAssistInfo';
import { AddCentsAssistInfoPayload, addCentsAssistInfo } from 'api/assist/addCentsAssistInfo';

export const useAddCentsAssistInfo = () => {
  return useMutation<
    AxiosResponse<CentsAssistInfo>,
    AxiosError<{ error: string }>,
    AddCentsAssistInfoPayload
  >({
    mutationFn: async (data) => {
      return addCentsAssistInfo(data);
    },
    onSuccess: async () => {
      toaster('Cents Assist info has been saved', {
        icon: '✅',
      });
    },
    onError: (error) => {
      Sentry.captureException(error);
      toaster(error?.response?.data?.error ?? 'An error occurred while saving Cents Assist info', {
        icon: '❌',
      });
      return error;
    },
  });
};
